var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/constants/constants.ts
var GalleryEvents = {
  applicationLoaded: "gallery_application_loaded",
  backClicked: "gallery_back_clicked",
  error: "gallery_error",
  userInteraction: "gallery_userinteraction",
  languageChanged: "gallery_language_changed",
  exitClicked: "gallery_close_clicked",
  summaryClicked: "gallery_summary_clicked",
  addProducts: "gallery_add_products",
  missingProduct: "gallery_missing_product_error",
  shoppingListClicked: "gallery_shopping_list_clicked",
  handleCountdownBanner: "gallery_handle_countdown_banner"
};
var UpptackaEvents = {
  applicationLoaded: "upptacka_application_loaded",
  backClicked: "upptacka_backclicked",
  error: "upptacka_error",
  userInteraction: "upptacka_userinteraction",
  languageChanged: "upptacka_language_changed",
  exitClicked: "upptacka_closeclicked",
  summaryClicked: "upptacka_summaryclicked",
  addProducts: "upptacka_addproducts",
  missingProduct: "upptacka_missing_product_error",
  shoppingListClicked: "upptacka_shopping_list_clicked",
  handleCountdownBanner: "upptacka_handle_countdown_banner"
};
var SessionStorage = {
  kioskIntegrationPlatform: "kiosk-integration-platform"
};

// src/utilities/post-message.ts
function postMessage(event, data, separator = ":") {
  window.parent.postMessage(
    {
      method: data ? `${event}${separator}${data}` : event
    },
    "*"
  );
}

// src/kiosk-integration/kiosk-integration.ts
var KioskIntegration = class {
  constructor(options) {
    __publicField(this, "platformEvents");
    __publicField(this, "debug");
    const params = new URLSearchParams(document.location.search);
    this.debug = options == null ? void 0 : options.debug;
    switch (true) {
      case ((options == null ? void 0 : options.platform) === "gallery" || params.get("ipexGallery") === "true"):
        this.platformEvents = GalleryEvents;
        sessionStorage.setItem(
          SessionStorage.kioskIntegrationPlatform,
          "gallery"
        );
        break;
      case ((options == null ? void 0 : options.platform) === "upptacka" || params.get("origin") === "upptacka"):
        this.platformEvents = UpptackaEvents;
        sessionStorage.setItem(
          SessionStorage.kioskIntegrationPlatform,
          "upptacka"
        );
        break;
      case sessionStorage.getItem(SessionStorage.kioskIntegrationPlatform) === "gallery":
        this.platformEvents = GalleryEvents;
        break;
      case sessionStorage.getItem(SessionStorage.kioskIntegrationPlatform) === "upptacka":
        this.platformEvents = UpptackaEvents;
        break;
      default:
        break;
    }
  }
  sendEvent(event, data, separator = ":") {
    if (!this.platformEvents) {
      return;
    }
    if (this.debug) {
      console.log({ event: this.platformEvents[event], data });
    }
    postMessage(this.platformEvents[event], data, separator);
  }
  addProducts(products) {
    const articles = products.map((item) => `${item.id}:${item.quantity}`).join(",");
    this.sendEvent("addProducts", articles, "=");
  }
  applicationLoaded() {
    this.sendEvent("applicationLoaded");
  }
  backClicked() {
    this.sendEvent("backClicked");
  }
  error(error) {
    this.sendEvent("error", error);
  }
  userInteraction() {
    this.sendEvent("userInteraction");
  }
  exitClicked() {
    this.sendEvent("exitClicked");
  }
  summaryClicked(plannerCode, type = "VPC") {
    this.sendEvent("summaryClicked", `${type}:${plannerCode}`, "=");
  }
  shoppingListClicked() {
    this.sendEvent("shoppingListClicked");
  }
  missingProduct(error) {
    this.sendEvent("missingProduct", error);
  }
  handleCountdownBanner() {
    this.sendEvent("handleCountdownBanner");
  }
  languageChange(locale) {
    if (this.platformEvents === GalleryEvents) {
      this.sendEvent("languageChanged", locale);
    }
  }
};
export {
  GalleryEvents,
  KioskIntegration,
  SessionStorage,
  UpptackaEvents
};
